import React from 'react';

import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

const BranchAccessForm =(props) => {
    return (
        <div>
            <Table>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow>
                        <TableHeaderColumn>AccessGroup</TableHeaderColumn>
                        <TableHeaderColumn>Country</TableHeaderColumn>
                        <TableHeaderColumn>Customer</TableHeaderColumn>
                        <TableHeaderColumn>Branch</TableHeaderColumn>
                        <TableHeaderColumn></TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} displayRowCheckbox={false}>
                    {props.useraccess && props.useraccess.map((cb, index) =>(
                            <TableRow key={index}>
                                <TableRowColumn>{cb.groupName}</TableRowColumn>
                                <TableRowColumn>{cb.countryName}</TableRowColumn>
                                <TableRowColumn>{cb.customerName}</TableRowColumn>
                                <TableRowColumn>{cb.branchName}</TableRowColumn>
                                <TableRowColumn>
                                    {cb.deleteable?
                                        <FlatButton label="Drop" onTouchTap={()=>{props.onUserAccessDeleteClicked(cb)}}/>:""
                                    }
                                </TableRowColumn>
                            </TableRow>
                        )
                    )}
                </TableBody>
            </Table>
        </div>
    )
};

export default BranchAccessForm;



// WEBPACK FOOTER //
// ./src/components/branchSelector/BranchAccessForm.js